import { ChevronLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function Header({ title, subtitle, back = false }) {
  const navigate = useNavigate();
  return (
    <header className="sticky top-0 z-40 glass border-b border-white/10 px-4 py-3">
      <div className="flex items-center gap-3">
        {back && (
          <button
            data-testid="back-button"
            onClick={() => navigate(-1)}
            className="w-9 h-9 grid place-items-center rounded-full bg-white/5 active:scale-95 transition"
          >
            <ChevronLeft size={22} />
          </button>
        )}
        <div className="min-w-0">
          <div data-testid="header-title" className="font-display text-lg font-bold leading-tight truncate">
            {title}
          </div>
          {subtitle && <div className="text-xs text-slate-400 truncate">{subtitle}</div>}
        </div>
        {!back && (
          <span className="ml-auto text-[10px] font-bold tracking-wider px-2.5 py-1 rounded-full bg-blue-500/15 text-blue-300 border border-blue-500/30">
            iOS
          </span>
        )}
      </div>
    </header>
  );
}
